import { ApolloClient, from as ApolloLinkFrom, HttpLink, InMemoryCache } from "@apollo/client";
import { onError } from "@apollo/client/link/error";
import * as Sentry from "@sentry/browser";
import { SentryLink } from "apollo-link-sentry";

const errorLink = onError(errorLinkErrors => {
  const { graphQLErrors, networkError } = errorLinkErrors;
  const errors = graphQLErrors || networkError;
  if (errors) {
    Sentry.captureException(errors);
  }
});

const sentryLink = new SentryLink({
  attachBreadcrumbs: {
    includeQuery: true,
    includeVariables: true,
    includeError: true,
  },
});

const httpNeosocieteApi = new HttpLink({
  uri: process.env.REACT_APP_API_NEOSOCIETE,
});

export const clientNeoSociete = new ApolloClient({
  link: ApolloLinkFrom([errorLink, sentryLink, httpNeosocieteApi]),
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: true,
    },
  },
});

const httpSaleManagementApi = new HttpLink({
  uri: process.env.REACT_APP_API_SALE_MANAGEMENT,
});

export const clientSaleManagement = new ApolloClient({
  link: ApolloLinkFrom([errorLink, sentryLink, httpSaleManagementApi]),
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: true,
    },
  },
});

